import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Import translation files
import enAuth from './locales/en/auth.json';
import esAuth from './locales/es/auth.json';
import ptAuth from './locales/pt/auth.json';
import viAuth from './locales/vi/auth.json';
import zhCNAuth from './locales/zh-CN/auth.json';
import enPonds from './locales/en/ponds.json';
import esPonds from './locales/es/ponds.json';
import ptPonds from './locales/pt/ponds.json';
import viPonds from './locales/vi/ponds.json';
import zhCNPonds from './locales/zh-CN/ponds.json';
import enHelp from './locales/en/help.json';
import esHelp from './locales/es/help.json';
import ptHelp from './locales/pt/help.json';
import viHelp from './locales/vi/help.json';
import zhCNHelp from './locales/zh-CN/help.json';
import enMain from './locales/en/main.json';
import esMain from './locales/es/main.json';
import ptMain from './locales/pt/main.json';
import viMain from './locales/vi/main.json';
import zhCNMain from './locales/zh-CN/main.json';
// Supported languages
export const SUPPORTED_LANGUAGES = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'pt', name: 'Português', flag: '🇧🇷' },
    { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
    { code: 'zh-CN', name: '简体中文', flag: '🇨🇳' },
];
// Language detection from localStorage or browser
const getInitialLanguage = () => {
    const stored = localStorage.getItem('pondlogs_locale');
    if (stored && SUPPORTED_LANGUAGES.some((lang) => lang.code === stored)) {
        return stored;
    }
    // Browser language detection
    const browserLang = navigator.language.split('-')[0];
    const match = SUPPORTED_LANGUAGES.find((lang) => lang.code.startsWith(browserLang));
    return match ? match.code : 'en';
};
// Initialize i18next
i18n.use(initReactI18next).init({
    resources: {
        en: { auth: enAuth, ponds: enPonds, help: enHelp, main: enMain },
        es: { auth: esAuth, ponds: esPonds, help: esHelp, main: esMain },
        pt: { auth: ptAuth, ponds: ptPonds, help: ptHelp, main: ptMain },
        vi: { auth: viAuth, ponds: viPonds, help: viHelp, main: viMain },
        'zh-CN': { auth: zhCNAuth, ponds: zhCNPonds, help: zhCNHelp, main: zhCNMain },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    defaultNS: 'auth',
    ns: ['auth', 'ponds', 'help', 'main'],
    interpolation: {
        escapeValue: false, // React already escapes
    },
    react: {
        useSuspense: false,
    },
});
// Persist language changes
i18n.on('languageChanged', (lng) => {
    localStorage.setItem('pondlogs_locale', lng);
});
export default i18n;
